export const LABELS = 'labels'
